module.exports = __webpack_public_path__ + "static/media/Ekenhälsan uses telemedicine software for digital healthcare.d2d61b07.webp";